import React, { useState, useEffect, useContext } from 'react';
import api from '../../api/axiosConfig';
import { SettingsContext } from '../../context/SettingsContext';

// Global RAM Cache (Prevents repeated API calls)
const memoryCache = {};

const T = ({ children }) => {
  const { language } = useContext(SettingsContext);
  const [translated, setTranslated] = useState(children);

  useEffect(() => {
    // 1. If English or empty, show original
    if (language === 'en' || !children) {
      setTranslated(children);
      return;
    }

    // 2. Check Memory Cache (Instant)
    const cacheKey = `${language}_${children}`;
    if (memoryCache[cacheKey]) {
      setTranslated(memoryCache[cacheKey]);
      return;
    }

    // 3. Fetch from Backend
    const fetchTranslation = async () => {
      try {
        // We use a POST request to send the text safely
        const res = await api.post('/translate', {
          text: children,
          targetLang: language
        });

        // 4. Save result
        const result = res.data.translatedText;
        memoryCache[cacheKey] = result;
        setTranslated(result);

      } catch (err) {
        console.error("Translation Error:", err);
        setTranslated(children); // Fallback to English
      }
    };

    fetchTranslation();
  }, [children, language]);

  return <>{translated}</>;
};

export default T;